// material-ui
import { Theme, TypographyVariantsOptions } from '@mui/material/styles';

// types
import { FontFamily, ThemeMode } from 'types/config';

// ==============================|| DEFAULT THEME - TYPOGRAPHY  ||============================== //

const Typography = (mode: ThemeMode, fontFamily: FontFamily, theme: Theme): TypographyVariantsOptions => ({
  htmlFontSize: 16,
  fontFamily,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    fontSize: '1.5rem', // 24px - Page titles
    lineHeight: 1.3,
    letterSpacing: '-0.01em'
  },
  h2: {
    fontWeight: 600,
    fontSize: '1.25rem', // 20px - Section headers
    lineHeight: 1.4
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.125rem', // 18px - Card titles
    lineHeight: 1.5
  },
  h4: {
    fontWeight: 600,
    fontSize: '1rem', // 16px - Subsection headers
    lineHeight: 1.5
  },
  h5: {
    fontWeight: 600,
    fontSize: '0.875rem', // 14px - Small headers
    lineHeight: 1.5
  },
  h6: {
    fontWeight: 500,
    fontSize: '0.75rem', // 12px - Smallest headers
    lineHeight: 1.5
  },
  caption: {
    fontWeight: 500,
    fontSize: '0.75rem', // 12px - Badges, secondary text
    lineHeight: 1.5
  },
  body1: {
    fontSize: '0.875rem', // 14px - Body text
    fontWeight: 400,
    lineHeight: 1.5
  },
  body2: {
    fontSize: '0.75rem', // 12px - Secondary body text
    fontWeight: 400,
    lineHeight: 1.5
  },
  subtitle1: {
    fontSize: '0.875rem', // 14px - Labels
    fontWeight: 500,
    lineHeight: 1.5
  },
  subtitle2: {
    fontSize: '0.75rem', // 12px - Small labels
    fontWeight: 500,
    lineHeight: 1.5
  },
  overline: {
    fontSize: '0.75rem', // 12px
    fontWeight: 500,
    lineHeight: 1.5,
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  button: {
    fontSize: '0.875rem', // 14px
    fontWeight: 500,
    lineHeight: 1.5,
    textTransform: 'capitalize'
  }
});

export default Typography;
